import React from 'react'
import CreateEditResourceForm from '../components/User/CreateEditResourceForm'
import { useParams } from 'react-router-dom'
const UpdateResource = () => {
  const {resourceId} = useParams();
  return <CreateEditResourceForm mode={"edit"} resourceId={resourceId} />
}

export {UpdateResource}